
import { routerReducer } from 'react-router-redux';

import omit from 'lodash/omit';
import map from 'lodash/map';
import without from 'lodash/without';

import { 
  OPEN_SHARED_MANAGEMENT_MODAL,
  CLOSE_SHARED_MANAGEMENT_MODAL,
  DESTROY_SHARED_MANAGEMENT_MODAL,
  UPDATE_SHARED_MANAGEMENT_MODAL
} from '../const/action_types.js';


import {
  PAGE_DETAILS_MODAL_NAME,
  LINK_DETAILS_MODAL_NAME,
  TEMPLATE_DETAILS_MODAL_NAME
} from '../const/modal_names.js';

import {
  deserializeDetailItem
} from 'zoomforth_shared_management/lib/details_modal_serializer.js';


export default (prevState = {}, action)=> {

  const state = routerReducer(prevState, action);

  switch (action.type) {

  case OPEN_SHARED_MANAGEMENT_MODAL:
    return { 
      ...state,
      [action.name]: {
        name: action.name,
        props: action.props
      },
      orderedModalNames: [ ...(state.orderedModalNames || []), action.name]

    };

  case UPDATE_SHARED_MANAGEMENT_MODAL: 
    return {
      ...state,
      [action.name]: {
        ...state[action.name],
        props: {
          ...(state[action.name] && state[action.name].props),
          ...action.props
        }
      }
    };

  case CLOSE_SHARED_MANAGEMENT_MODAL:
    return {
      ...state,
      [action.name]: {
        ...state[action.name],
        isClosing: true
      }
    };

  case DESTROY_SHARED_MANAGEMENT_MODAL:
    return {
      ...omit(state, [action.name]),
      orderedModalNames: without(state.orderedModalNames, action.name)
    };

  default:
    return state;

  }
};

/**
  Return the modals in the format:

  [
    name: <MODAL_NAME>,
    props: {
      prop1: <...>
      prop2: <...>
    }
  ]
  
  Modals are added to an stack-like-array (i.e., an array treated like a stack) so the last 
  modal opened appears at the end of the array.

  Both the "details" modals and the rest of the modals have their own stack-like-array,
  such that details modals always appear beneath the rest (while still behaving like a stack)
*/
export const getModals = (state)=> {
  const details = getLocationBeforeTransitions(state).query.details;
  const detailItems = map(details ? details.split(';') : null, deserializeDetailItem);

  return (
    // Always render the "detail" modals before other modals (so they render underneath)
    map(
      detailItems, 
      (detailItem)=>
        getDetailModalDataFromDeserializedDetailItem(state, detailItem)
    )
    // Render all other modals
    .concat(
      // Note that modals 
      map(state.orderedModalNames, (id)=> state[id])
    )
  );
};


const getDetailModalDataFromDeserializedDetailItem = (state, { type, id, tab })=> {
  const pseudoName = `${type}-${id}`;
  return (
    (
      // June 2019 the page/site details URL was changed from 'page' to 'site'
      // we ensure that 'page' continues to work to support old URLs
      type === 'site' || 
      type === 'page'
    ) ?
    { 
      name: PAGE_DETAILS_MODAL_NAME,
      props: {
        pageId: id,
        selectedTab: tab,
        ...(state[pseudoName] && state[pseudoName].props)
      }

    }

    : type === 'template' ?
    { 
      name: TEMPLATE_DETAILS_MODAL_NAME,
      props: {
        templateId: id,
        selectedTab: tab,
        ...(state[pseudoName] && state[pseudoName].props)
      }
    }

    : // type === 'link'
    { 
      name: LINK_DETAILS_MODAL_NAME,
      props: {
        routeId: id,
        selectedTab: tab,
        ...(state[pseudoName] && state[pseudoName].props)
      }
    }
  );
};


export const getLocationBeforeTransitions = (state)=>
  state.locationBeforeTransitions;

